/*
defines functionality for backing up and restoring nodes and links from external db
*/

/**
 * represents a controller for imports / exports
 */
export default class BackupController {

    /**
     * makes a new backup controller given a graph controller, model, and view
     * @param {GraphController} graphController the graph controller to use
     * @param {Graph} model the graph model instance to use
     * @param {GraphView} view the graph view to use
     */
    constructor(graphController, model, view) {
        this.graphController = graphController;
        this.model = model;
        this.view = view;
    }
    /**
     * import an old/existing network of nodes into the controller and view
     */
    importModel() {
        let importNodeFromModel = (node) => {
            let newNodeView = this.view.addNode(node, this.view.width / 2, this.view.height / 2);
            node.setUpdateCallback(newNodeView.updateCallback);
        };

        let importLinkFromModel = (link) => this.view.addLink(link);

        this.model.nodes.forEach(importNodeFromModel);
        this.model.links.forEach(importLinkFromModel);
        this.graphController.update();
    }

}